module.exports = require("@swa-ui/hybrid");